export const WorkspaceJobType = {
  AutoBriefingSocial: 'auto_briefing_social',
  Briefing: 'briefing',
}
